import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ar: {
    // Common
    app_title: 'توثيق استلام دواء X',
    welcome: 'مرحباً بك',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    save: 'حفظ',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    confirm: 'تأكيد',
    search: 'بحث',
    filter: 'تصفية',
    export: 'تصدير',
    actions: 'الإجراءات',
    loading: 'جاري التحميل...',
    no_data: 'لا توجد بيانات',
    
    // Auth
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    login_title: 'تسجيل الدخول إلى النظام',
    login_subtitle: 'أدخل بيانات الاعتماد للوصول إلى النظام',
    invalid_credentials: 'بيانات الاعتماد غير صحيحة',
    
    // Navigation
    dashboard: 'لوحة التحكم',
    new_receipt: 'مريض جديد',
    receipts_list: 'قائمة السجلات',
    statistics: 'الإحصائيات',
    users_management: 'إدارة المستخدمين',
    support_contact: 'الدعم الفني',
    
    // Receipt Form
    patient_name: 'اسم المريض',
    patient_id_number: 'رقم البطاقة الشخصية',
    patient_age: 'عمر المريض',
    receipt_date: 'تاريخ الاستلام',
    medication_type: 'نوع الدواء',
    medication_x: 'دواء X',
    hospital_name: 'المستشفى المستلم',
    receiving_area: 'موقع التوزيع',
    receipt_status: 'حالة استلام الدواء',
    received: 'تم الاستلام',
    not_received: 'لم يستلم',
    preparing: 'قيد التحضير / سبق له الاستلام',
    reception_signature: 'توقيع الاستقبال',
    notify_hospital: 'إعلام المستشفى',
    notify_hospital_desc: 'أوافق على إبلاغ المستشفى عن استلام المريض للدواء',
    submit_receipt: 'تسجيل المريض',
    
    // New fields
    receipt_type: 'نوع الاستلام',
    receipt_self: 'يستلم لنفسه',
    receipt_family: 'يستلم عن العائلة',
    family_members: 'أفراد العائلة',
    add_family_member: 'إضافة فرد من العائلة',
    remove: 'إزالة',
    dose_mg: 'عدد الحبات',
    tablet: 'حبة',
    tablets: 'حبات',
    calculated_tablets: 'الحبات المحسوبة',
    has_allergy: 'حالة الحساسية',
    no_allergy: 'لا توجد حساسية',
    has_allergy_yes: 'توجد حساسية',
    allergy_notes: 'ملاحظات الحساسية',
    medical_notes: 'الملاحظات الطبية',
    allergy_warning: 'تحذير: لا يمكن صرف الدواء بسبب وجود حساسية!',
    prevented_reason: 'سبب المنع',
    scan_barcode: 'مسح الباركود',
    barcode_hint: 'قم بمسح البطاقة الشخصية باستخدام قارئ الباركود',
    recipient_name: 'اسم المستلم',
    family_count: 'عدد أفراد العائلة',
    self_recipient: 'لنفسه',
    stock_insufficient: 'المخزون غير كافٍ',
    total_dose: 'إجمالي الجرعة',
    age: 'العمر',
    age_required: 'العمر مطلوب',
    age_invalid: 'العمر غير صحيح',
    tablets_auto: 'يتم حساب الحبات تلقائياً حسب العمر',
    admin_override: 'تعديل المدير',
    return_tablets: 'إرجاع حبات',
    
    // Receipts List
    receipts_title: 'قائمة استلام دواء X',
    created_by: 'مسجل بواسطة',
    created_at: 'تاريخ التسجيل',
    
    // Statistics
    stats_title: 'إحصائيات استلام الدواء',
    total_received: 'تم الاستلام',
    total_not_received: 'لم يستلم',
    total_preparing: 'قيد التحضير',
    total_records: 'إجمالي السجلات',
    total_allergy_prevented: 'حالات منع بسبب الحساسية',
    by_hospital: 'حسب المستشفى',
    by_dose: 'حسب الجرعة',
    recent_records: 'آخر السجلات',
    status_legend: 'دليل الألوان',
    
    // Reports
    reports_title: 'التقارير الإدارية',
    filter_by_date: 'تصفية حسب التاريخ',
    start_date: 'من تاريخ',
    end_date: 'إلى تاريخ',
    filter_by_hospital: 'تصفية حسب المستشفى',
    filter_by_receiving_area: 'تصفية حسب موقع التوزيع',
    filter_by_dose: 'تصفية حسب الجرعة',
    apply_filters: 'تطبيق التصفية',
    reset_filters: 'إعادة تعيين',
    
    // Audit Log
    audit_log: 'سجل التعديلات',
    action: 'الإجراء',
    timestamp: 'الوقت',
    user: 'المستخدم',
    changes: 'التغييرات',
    
    // Users
    users_title: 'إدارة المستخدمين',
    full_name: 'الاسم الكامل',
    role: 'الدور',
    admin: 'المدير العام',
    admin_role: 'مسؤول النظام',
    receptionist: 'صيدلي',
    inventory_admin: 'مدير المخزون',
    add_user: 'إضافة مستخدم',
    
    // Inventory
    inventory: 'إدارة المخزون',
    main_inventory: 'المخزون الرئيسي',
    distributed: 'الموزع',
    available: 'المتاح للتوزيع',
    locations: 'مواقع التوزيع',
    add_location: 'إضافة موقع توزيع',
    distribution_locations: 'مواقع التوزيع',
    distribute: 'توزيع',
    dispensed: 'المصروف',
    remaining: 'المتبقي',
    location_name: 'اسم الموقع',
    location_type: 'نوع الموقع',
    dose_rules: 'قواعد حساب الجرعة',
    clear_history: 'مسح السجل',
    clear_history_confirm: 'هل أنت متأكد من مسح جميع سجلات المعاملات؟ لا يمكن التراجع عن هذا الإجراء.',
    
    // Export
    export_excel: 'تصدير Excel',
    export_pdf: 'تصدير PDF',
    
    // Messages
    receipt_created: 'تم تسجيل المريض بنجاح',
    receipt_updated: 'تم تحديث السجل بنجاح',
    receipt_deleted: 'تم حذف السجل بنجاح',
    user_created: 'تم إضافة المستخدم بنجاح',
    user_deleted: 'تم حذف المستخدم بنجاح',
    confirm_delete: 'هل أنت متأكد من الحذف؟',
    
    // Intro
    intro_text: 'مرحبًا بكم في موقعنا المخصص لتوثيق استلام دواء X. يهدف هذا الموقع إلى تسجيل استلام دواء X وضمان تتبع دقيق للجرعات.',
    
    // Footer
    permissions_note: 'فقط الصيادلة والمشرفون لديهم صلاحيات لتعديل أو حذف أي سجلات.',
  },
  en: {
    // Common
    app_title: 'Medication X Receipt Documentation',
    welcome: 'Welcome',
    login: 'Login',
    logout: 'Logout',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    confirm: 'Confirm',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    actions: 'Actions',
    loading: 'Loading...',
    no_data: 'No data available',
    
    // Auth
    username: 'Username',
    password: 'Password',
    login_title: 'Login to System',
    login_subtitle: 'Enter your credentials to access the system',
    invalid_credentials: 'Invalid credentials',
    
    // Navigation
    dashboard: 'Dashboard',
    new_receipt: 'New Patient',
    receipts_list: 'Records List',
    statistics: 'Statistics',
    users_management: 'Users Management',
    support_contact: 'Support',
    
    // Receipt Form
    patient_name: 'Patient Name',
    patient_id_number: 'ID Card Number',
    patient_age: 'Patient Age',
    receipt_date: 'Receipt Date',
    medication_type: 'Medication Type',
    medication_x: 'Medication X',
    hospital_name: 'Receiving Hospital',
    receiving_area: 'Distribution Location',
    receipt_status: 'Medication Receipt Status',
    received: 'Received',
    not_received: 'Not Received',
    preparing: 'Preparing / Previously Received',
    reception_signature: 'Reception Signature',
    notify_hospital: 'Notify Hospital',
    notify_hospital_desc: 'I agree to notify the hospital about the patient receiving the medication',
    submit_receipt: 'Register Patient',
    
    // New fields
    receipt_type: 'Receipt Type',
    receipt_self: 'For Self',
    receipt_family: 'For Family',
    family_members: 'Family Members',
    add_family_member: 'Add Family Member',
    remove: 'Remove',
    dose_mg: 'Number of Tablets',
    tablet: 'Tablet',
    tablets: 'Tablets',
    calculated_tablets: 'Calculated Tablets',
    has_allergy: 'Allergy Status',
    no_allergy: 'No Allergy',
    has_allergy_yes: 'Has Allergy',
    allergy_notes: 'Allergy Notes',
    medical_notes: 'Medical Notes',
    allergy_warning: 'Warning: Cannot dispense medication due to allergy!',
    prevented_reason: 'Prevention Reason',
    scan_barcode: 'Scan Barcode',
    barcode_hint: 'Scan the ID card using the barcode scanner',
    recipient_name: 'Recipient Name',
    family_count: 'Family Members Count',
    self_recipient: 'Self',
    stock_insufficient: 'Insufficient Stock',
    total_dose: 'Total Dose',
    age: 'Age',
    age_required: 'Age is required',
    age_invalid: 'Invalid age',
    tablets_auto: 'Tablets are calculated automatically based on age',
    admin_override: 'Admin Override',
    return_tablets: 'Return Tablets',
    
    // Receipts List
    receipts_title: 'Medication X Receipt List',
    created_by: 'Created by',
    created_at: 'Created at',
    
    // Statistics
    stats_title: 'Medication Receipt Statistics',
    total_received: 'Received',
    total_not_received: 'Not Received',
    total_preparing: 'Preparing',
    total_records: 'Total Records',
    total_allergy_prevented: 'Allergy Prevention Cases',
    by_hospital: 'By Hospital',
    by_dose: 'By Dose',
    recent_records: 'Recent Records',
    status_legend: 'Status Legend',
    
    // Reports
    reports_title: 'Administrative Reports',
    filter_by_date: 'Filter by Date',
    start_date: 'Start Date',
    end_date: 'End Date',
    filter_by_hospital: 'Filter by Hospital',
    filter_by_receiving_area: 'Filter by Distribution Location',
    filter_by_dose: 'Filter by Dose',
    apply_filters: 'Apply Filters',
    reset_filters: 'Reset',
    
    // Audit Log
    audit_log: 'Audit Log',
    action: 'Action',
    timestamp: 'Timestamp',
    user: 'User',
    changes: 'Changes',
    
    // Users
    users_title: 'Users Management',
    full_name: 'Full Name',
    role: 'Role',
    admin: 'Super Admin',
    admin_role: 'Admin Role',
    receptionist: 'Pharmacist',
    inventory_admin: 'Inventory Admin',
    add_user: 'Add User',
    
    // Inventory
    inventory: 'Inventory Management',
    main_inventory: 'Main Inventory',
    distributed: 'Distributed',
    available: 'Available',
    locations: 'Distribution Locations',
    add_location: 'Add Distribution Location',
    distribution_locations: 'Distribution Locations',
    distribute: 'Distribute',
    dispensed: 'Dispensed',
    remaining: 'Remaining',
    location_name: 'Location Name',
    location_type: 'Location Type',
    dose_rules: 'Dose Calculation Rules',
    clear_history: 'Clear History',
    clear_history_confirm: 'Are you sure you want to clear all transaction history? This action cannot be undone.',
    
    // Export
    export_excel: 'Export Excel',
    export_pdf: 'Export PDF',
    
    // Messages
    receipt_created: 'Patient registered successfully',
    receipt_updated: 'Record updated successfully',
    receipt_deleted: 'Record deleted successfully',
    user_created: 'User created successfully',
    user_deleted: 'User deleted successfully',
    confirm_delete: 'Are you sure you want to delete?',
    
    // Intro
    intro_text: 'Welcome to our website dedicated to documenting Medication X receipts. This website aims to record Medication X receipts and ensure accurate dose tracking.',
    
    // Footer
    permissions_note: 'Only pharmacists and supervisors have permissions to edit or delete any records.',
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'ar';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ar' ? 'en' : 'ar');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, isRTL: language === 'ar' }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
